import script from "./Avatar.vue?vue&type=script&setup=true&lang=ts"
export * from "./Avatar.vue?vue&type=script&setup=true&lang=ts"

import "./Avatar.vue?vue&type=style&index=0&id=21d5bc58&lang=scss&scoped=true"

import exportComponent from "E:\\work\\EEEEE\\okpay\\ipay-imi\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-21d5bc58"]])

export default __exports__